import { render, staticRenderFns } from "./NewCreateGestaoDeAEE.vue?vue&type=template&id=1ab7fa7f"
import script from "./NewCreateGestaoDeAEE.vue?vue&type=script&lang=js"
export * from "./NewCreateGestaoDeAEE.vue?vue&type=script&lang=js"
import style0 from "./NewCreateGestaoDeAEE.vue?vue&type=style&index=0&id=1ab7fa7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports